import { Component, Element, h, Host, Prop } from '@stencil/core';
import { addClass, isEmpty } from '../../utils/helpers/helpers';

@Component({
  tag: 'lgr-tag',
  styleUrl: 'tag.scss',
  shadow: true,
})
export class Tag {
  @Element() el!: HTMLLgrTagElement;
  /**
   * disabled state
   */
  @Prop({ reflect: true }) disabled: boolean = false;
  /**
   * inverse or not.
   */
  @Prop({ reflect: true }) inverse: boolean = false;
  /**
   * the text to be displayed inside the tag.
   */
  @Prop({ reflect: true }) tag?: string;
  /**
   * variant: default, error, success or primary.
   */
  @Prop({ reflect: true }) variant: 'success' | 'error' | 'warning' | 'default' | 'primary' = 'default';

  render() {
    return (
      <Host>
        <div
          class={addClass(['lgr-marker', this.disabled ? 'disabled' : null, this.inverse ? 'inverse' : null, isEmpty(this.tag) ? 'empty-marker' : 'filled-marker', this.variant])}
        >
          {!isEmpty(this.tag) && <p>{this.tag}</p>}
        </div>
      </Host>
    );
  }
}
